module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_5010.ffbb5a84.png";